module.exports = __webpack_public_path__ + "static/media/video-call.76125967.svg";